import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * copyright (c) 2017 wells fargo. 455 market st., san francisco, ca 94105 all rights reserved.
 *
 * this software is the confidential and proprietary information of wells fargo
 * bank. ('confidential information'). you shall not disclose such confidential
 * information and shall use it only in accordance with the terms of the license
 * agreement you entered into with wellsfargo.
 *
 * author: thomas barry
 *
 * description:
 *
 * part of a work-around to fix an issue with voiceover (ios) in which voiceover does not
 * follow focus to a newly opened child window. the <page> component includes this component and
 * the create-focus-trap module sets focus on the element created here before moving it to the
 * element that *should* have focus.
 * */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './AccessibilityFocus.less';
export default (function () {
  var _useState = useState(document.createElement('div')),
      _useState2 = _slicedToArray(_useState, 1),
      el = _useState2[0];

  useEffect(function () {
    document.body.appendChild(el);
  }, []);
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    tabIndex: "-1",
    id: "accessibilityFocus",
    className: styles.accessibilityFocus
  }), el);
});